import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import {
  getAreas,
  getCities,
  getSearchNumbers,
  getCat,
  getMarketer,
  getCustomer,
  getAddCustomer,
  getCustomerData,
  getCrmData,
  getChangeResponsible,
  getDeleteUserFile,
  getOnlineInvoice,
  getOfflineInvoice,
  getEditCustomer,
  getAddNewAddress,
  getAddAction,
  getDeleteAction,
  getSwitchAction,
  getDelayAction,
  getActionsDelayed,
  getEditActivity,
  getRestoreCustomer,
  getNotDoneAction,
  getActionComments,
  getAddComment,
  getHistoryList,
  getChangeOfflineInvoiceTag,
  getChangeOfflineInvoiceResponsible,
  getChangeOfflineInvoiceStatus,
  getChangeOnlineInvoiceTag,
  getChangeOnlineInvoiceResponsible,
  getNotes,
  getAddNote,
  getDeleteNote,
  getEditNote,
  getTradesList,
  getDeleteOfflineInvoice,
  getTransactionFilter,
  getUsersList,
  getBrands,
  getFilterCrmFile,
  getSearchUser,
  getInvoicelessCustomer,
  getActivitiesDoneToday,
  getActivitiesToday,
  getChangeActionsDate,
  getDeleteActivity,
  getCrmMarkerData,
  getUsersWithoutActivity,
  getFirstFiles,
  getChangeFirstFileResponsible,
  getAllActivities,
  getPassedActivities,
  getClueWithoutActivity,
  getCustomersWithoutActivity,
  getTransactionsBasedOnUser,
  getFilterTransactionsBasedOnUser,
  getDeletedUsers,
  getQuickInvoice,
  getFilterMarker,
  getCrmDashboard,
  getChatData,
  getChatBox,
  getCompanyUsers,
  getReferChat,
  getSupplierList,
  getProvienceChart,
  getUnreadTicketsNumber,
  getInsertTag,
  getShowTag,
  getEditTag,
  getGrouping,
  getInsertGrouping,
  getUpdateGroupingItem,
  getUpdateGroupingItemStatus,
  getChangeStatusApp,
  getGroupingData,
  getEditOfflineInvoice,
  getEditOnlineInvoice,
  getChangeAllActionsType,
  getMergeList,
  getDeleteMergeItem,
  addMergeItem,
  updateMergeItem,
  getInsertUrl,
  getUrlList,
  getUrlView,
  getUpdateUrl,
  getSellChart,
  getAnswerAction,
  changeStatusLeaveRequest,
} from "../services/crm";
import { errorMessage, successMessage } from "../utils/message";

export const useSearchNumbers = () =>
  useMutation(getSearchNumbers, {
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });

export const useGetCustomerData = () => useMutation(getCustomerData);

export const useGetHistotyList = (id) =>
  useQuery("history-list", () => getHistoryList(id));

export const useOnlineInvoice = (OnlineInvoice) =>
  useQuery(["get-online-invoices", OnlineInvoice], () =>
    getOnlineInvoice(OnlineInvoice)
  );
export const useChangeOnlineInvoiceTag = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeOnlineInvoiceTag, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-online-invoices");
      successMessage("برچسب فاکتور با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useChangeOnlineInvoiceResponsible = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeOnlineInvoiceResponsible, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-online-invoices");
      successMessage("مسئول فاکتور با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useGetNotes = (id) =>
  useQuery(["get-notes", id], () => getNotes(id));

export const useAddNote = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddNote, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-notes");
      successMessage("یادداشت با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useDeleteNote = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteNote, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-notes");
      successMessage("یادداشت با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useEditNote = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditNote, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-notes");
      successMessage("ویرایش یادداشت با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useOfflineInvoice = (OfflineInvoice) =>
  useQuery(["get-offline-invoices", OfflineInvoice], () =>
    getOfflineInvoice(OfflineInvoice)
  );

export const useGetUsersList = () => useQuery("users-list", getUsersList);

export const useGetFirstFiles = () => useQuery("first-files", getFirstFiles);

export const useGetCrmDashboard = () =>
  useQuery("crm-dashboard", getCrmDashboard);

export const useChangeFirstFileResponsible = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeFirstFileResponsible, {
    onSuccess: () => {
      queryClient.invalidateQueries("first-files");
      successMessage("مسئول پرونده با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useGetTradesList = (pagenumber) =>
  useInfiniteQuery(
    "trades-list",
    ({ pageParam = 1 }) => getTradesList(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
export const useGetAllActivities = (data) =>
  // useInfiniteQuery(
  //   "all-activities",
  //   ({ pageParam = 1 }) => getAllActivities(pageParam),
  //   {
  //     getNextPageParam: (lastPage, allPages) => {
  //       return allPages.length + 1;
  //     },
  //   }
  // );
  useQuery("all-activities", () => getAllActivities(data));
export const useGetTransactionsBasedOnUser = () =>
  useQuery("transaction-based-person", getTransactionsBasedOnUser);

export const useGetClueWithoutActivity = () =>
  useQuery("clues-without-activity", getClueWithoutActivity);
export const useGetCustomersWithoutActivity = () =>
  useQuery("users-without-activity", getCustomersWithoutActivity);
export const useGetPassedActivities = () =>
  useInfiniteQuery(
    "passed-activities",
    ({ pageParam = 1 }) => getPassedActivities(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
export const useGetTransactionFilter = ({
  FactorTag,
  IdMarketer,
  Start,
  End,
}) =>
  useInfiniteQuery(
    ["transaction-filter", FactorTag, IdMarketer, { Start, End }],
    ({ pageParam = 1 }) =>
      getTransactionFilter(pageParam, FactorTag, IdMarketer, Start, End),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
// export const useFilterCrmFile = () => {
//   const queryClient = useQueryClient();
//   return useMutation(getFilterCrmFile, {
//     onSuccess: () => {
//       queryClient.invalidateQueries("users-list");
//     },
//     onError: () => {},
//   });
// };
export const useFilterCrmFile = (form, pageNumber) =>
  useInfiniteQuery(
    ["crm-filter-file"],
    ({ pageParam = 1 }) => getFilterCrmFile(form, pageNumber),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
      enabled: false,
    }
  );

export const useGetCrmMarkerData = () =>
  useQuery("get-crmMarker-data", getCrmMarkerData);
export const useGetAreas = () => useQuery("get-areas", getAreas);

export const useGetCities = () => useQuery("get-cities", getCities);

export const useGetCategory = () => useQuery("get-cat", getCat);

export const useGetBrands = () => useQuery("get-brands", getBrands);

export const useGetMarketer = () => useQuery("get-marketer", getMarketer);

export const useGetCustomer = () => useQuery("get-customer", getCustomer);

export const useActionsDelayed = (idActivity) =>
  useQuery(["get-delayed-action", idActivity], () =>
    getActionsDelayed(idActivity)
  );
export const useSearchFile = (search) =>
  useQuery(["search-file"], () => getSearchUser(search), { enabled: false });

export const useCrmData = (data) =>
  useQuery(["crm-data", data], () => getCrmData(data), {
    onSuccess: () => {},
    onError: () => {},
  });
export const useAddCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useGetQuickInvoice = () => {
  const queryClient = useQueryClient();
  return useMutation(getQuickInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      queryClient.invalidateQueries("crm-data");
      successMessage("فاکتور سریع با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useFilterMarker = () => {
  const queryClinet = useQueryClient();
  return useMutation(getFilterMarker, {
    onSuccess: () => {},
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useEditCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("پرونده با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useGetActivitiesDoneToday = () =>
  useQuery("activities-done-today", getActivitiesDoneToday);
export const useGetActivitiesToday = () =>
  useQuery("activities-today", getActivitiesToday);
export const useRestoreCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation(getRestoreCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("مشتری با موفقیت بازگردانده شد ");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useChangeResponsible = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeResponsible, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("مسئول پرونده با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useAddNewAddress = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddNewAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("آدرس جدید با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useAddAction = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("فعالیت جدید با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useDeleteAction = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("فعالیت مورد نظر با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useSwitchAction = () => {
  const queryClient = useQueryClient();
  return useMutation(getSwitchAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("وضعیت فعالیت با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useDelayAction = () => {
  const queryClient = useQueryClient();
  return useMutation(getDelayAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("به تاخیر افتادن فعالیت با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useEditData = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditActivity, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      queryClient.invalidateQueries("all-activities");
      queryClient.invalidateQueries("passed-activities");
      successMessage("ویرایش فعالیت با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useDeleteUserFile = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteUserFile, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("مشتری با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("فیلد های خالی را پر کنید");
    },
  });
};
export const useActionNotDone = (IdActivityCrm) => {
  const queryClient = useQueryClient();
  return useMutation(getNotDoneAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("تغییرات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useChangeStatusLeaveRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(changeStatusLeaveRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries("leave-req-admin-list");
      successMessage("تبدیل به انجام نشده");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useChangeOfflineInvoiceTag = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeOfflineInvoiceTag, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      successMessage("برچسب فاکتور با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useChangeOfflineInvoiceResponsible = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeOfflineInvoiceResponsible, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      successMessage("مسئول فاکتور با موفقیت تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useChangeOfflineInvoiceStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeOfflineInvoiceStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useDeleteOfflineInvoice = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteOfflineInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useActionComments = (IdActivityCrm) =>
  useQuery(["action-comment", IdActivityCrm], () =>
    getActionComments(IdActivityCrm)
  );

export const useAddComment = () => {
  const queryClient = useQueryClient();
  return useMutation(getAddComment, {
    onSuccess: () => {
      queryClient.invalidateQueries("action-comment");
      successMessage("کامنت شما با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("فیلد خالی را پر کنید");
    },
  });
};
export const useFilterTransactionsBasedOnUser = () => {
  const queryClient = useQueryClient();
  return useMutation(getFilterTransactionsBasedOnUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("transaction-based-person");
    },
    onError: () => {
      errorMessage("فیلد های مورد نظر را پر کنید");
    },
  });
};
export const useGetInvoicelessCustomer = () =>
  useQuery("invoiceless-customer", getInvoicelessCustomer);

export const useGetChangeActionsDate = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeActionsDate, {
    onSuccess: () => {
      queryClient.invalidateQueries("activities-today");
      queryClient.invalidateQueries("all-activities");
      queryClient.invalidateQueries("passed-activities");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetDeleteActivity = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteActivity, {
    onSuccess: () => {
      queryClient.invalidateQueries("activities-today");
      queryClient.invalidateQueries("all-activities");
      queryClient.invalidateQueries("passed-activities");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useGetUsersWithoutActivity = () =>
  useQuery("users-without-activity", getUsersWithoutActivity);

// export const useGetDeletedUsers = () =>
//   useQuery("deleted-Files", getDeletedUsers);

export const useGetDeletedUsers = () =>
  useInfiniteQuery(
    "deleted-Files",
    ({ pageParam }) => getDeletedUsers(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetChatData = () => useQuery("chat-data", getChatData);

export const useGetChatBox = () => {
  const queryClient = useQueryClient();
  return useMutation(getChatBox, {
    onSuccess: () => {
      queryClient.invalidateQueries("chat-data");
    },
  });
};

export const useGetCompanyUsers = () =>
  useQuery("company-users", getCompanyUsers);

export const useReferChat = () => {
  const queryClient = useQueryClient();
  return useMutation(getReferChat, {
    onSuccess: () => {
      queryClient.invalidateQueries("chat-data");
      successMessage("با موفقیت ارجاع داده شد");
    },
    onError: () => {
      errorMessage("ارجاع با خطا مواجه شد");
    },
  });
};

export const useGetSupplierList = () =>
  useQuery("supplier-list", getSupplierList);

export const useProvienceChart = (data) =>
  useQuery("provience-chart", () => getProvienceChart(data));

export const useGetUnreadTicketsNumber = () =>
  useQuery("tickets-number", getUnreadTicketsNumber);

export const useShowTag = () => useQuery("show-tag", getShowTag);

export const useInsertTag = () => {
  const queryClient = useQueryClient();
  return useMutation(getInsertTag, {
    onSuccess: () => {
      queryClient.invalidateQueries("show-tag");
      successMessage("برچسب با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("افزودن برچسب با خطا مواجه شد");
    },
  });
};

export const useEditTag = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditTag, {
    onSuccess: () => {
      queryClient.invalidateQueries("show-tag");
      successMessage("برچسب با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("ویرایش برچسب با خطا مواجه شد");
    },
  });
};

export const useGetGroupingList = () => useQuery("grouping-list", getGrouping);

export const useGetInsertGrouping = () => {
  const queryClient = useQueryClient();
  return useMutation(getInsertGrouping, {
    onSuccess: () => {
      queryClient.invalidateQueries("grouping-list");
      successMessage("دسته بندی با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetUpdateGroupingItem = () => {
  const queryClient = useQueryClient();
  return useMutation(getUpdateGroupingItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("grouping-list");
      successMessage("دسته بندی با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useGetUpdateGroupingItemStatus = () => {
  const queryClient = useQueryClient();
  return useMutation(getUpdateGroupingItemStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries("grouping-list");
      successMessage("وضعیت دسته بندی با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetChangeStatusApp = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeStatusApp, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetGroupingData = () =>
  useQuery("grouping-data", getGroupingData);

export const useGetEditOfflineInvoice = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditOfflineInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-offline-invoices");
      successMessage("فاکتور با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("ویرایش فاکتور با خطا مواجه شد");
    },
  });
};

export const useGetEditOnlineInvoice = () => {
  const queryClient = useQueryClient();
  return useMutation(getEditOnlineInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries("get-online-invoices");
      successMessage("فاکتور با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("ویرایش فاکتور با خطا مواجه شد");
    },
  });
};

export const useGetChangeAllActionsType = () => {
  const queryClient = useQueryClient();
  return useMutation(getChangeAllActionsType, {
    onSuccess: () => {
      queryClient.invalidateQueries("all-activities");
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetMergeList = (data) =>
  useQuery("merge-list", () => getMergeList(data));

export const useDeleteMergeItem = () => {
  const queryClient = useQueryClient();
  return useMutation(getDeleteMergeItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("merge-list");
      successMessage("پرونده از لیست حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useAddMergeItem = () => {
  const queryClient = useQueryClient();
  return useMutation(addMergeItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("merge-list");
      successMessage("پرونده به لیست اضافه شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
export const useUpdateMergeItem = () => {
  const queryClient = useQueryClient();
  return useMutation(updateMergeItem, {
    onSuccess: () => {
      queryClient.invalidateQueries("merge-list");
      successMessage("وضعیت پرونده به پرونده اصلی تغییر کرد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetUrlList = () => useQuery("url-list", getUrlList);

export const useGetUrlView = () => useQuery("url-view", getUrlView);

export const useGetInsertUrl = () => {
  const queryClient = useQueryClient();
  return useMutation(getInsertUrl, {
    onSuccess: () => {
      queryClient.invalidateQueries("url-list");
      successMessage("با موفقیت افزوده شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetUpdateUrl = () => {
  const queryClient = useQueryClient();
  return useMutation(getUpdateUrl, {
    onSuccess: () => {
      queryClient.invalidateQueries("url-list");
      successMessage("با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetChartSell = (data) =>
  useQuery("chart-sell", () => getSellChart(data), {
    enabled: false,
  });

export const useGetAnswerAction = () => {
  const queryClient = useQueryClient();
  return useMutation(getAnswerAction, {
    onSuccess: () => {
      queryClient.invalidateQueries("crm-data");
      successMessage("پاسخ فعالیت با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
